import { render, staticRenderFns } from "./stadium_cooperation_info.vue?vue&type=template&id=165b763c&"
import script from "./stadium_cooperation_info.vue?vue&type=script&lang=ts&"
export * from "./stadium_cooperation_info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports